import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FileSearch } from "lucide-react";

/**
 * AppEntry - Native app entry screen for iOS/Android (Capacitor)
 * This screen replaces the marketing landing page when the app is opened natively.
 * Clean, minimal, product-focused - no marketing content.
 */
const AppEntry = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-6">
      {/* Logo & App Name */}
      <div className="flex flex-col items-center mb-12">
        <div className="w-20 h-20 bg-primary/10 rounded-2xl flex items-center justify-center mb-4">
          <FileSearch className="w-10 h-10 text-primary" />
        </div>
        <h1 className="text-2xl font-semibold text-foreground">EasyFinder</h1>
      </div>

      {/* Value proposition - one line, no marketing */}
      <p className="text-muted-foreground text-center text-lg mb-12 max-w-xs">
        Tous vos documents importants, accessibles en un instant.
      </p>

      {/* Action buttons */}
      <div className="w-full max-w-xs space-y-3">
        <Button 
          onClick={() => navigate("/auth?mode=login")} 
          className="w-full h-12 text-base"
        >
          Se connecter
        </Button>
        <Button 
          onClick={() => navigate("/auth?mode=signup")} 
          variant="outline"
          className="w-full h-12 text-base"
        >
          Créer un compte
        </Button>
        <Button
          onClick={() => navigate("/landing")}
          variant="ghost"
          className="w-full h-12 text-base"
        >
          Voir la landing
        </Button>
      </div>
    </div>
  );
};

export default AppEntry;
